<template>
  <div :class="`mode-info ${design}`">
    <i class="fas fa-info-circle"></i>
    <span>
      <slot></slot>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    design: { type: String, default: 'gold' },
  },
};
</script>
<style scoped>
.mode-info {
  padding: 10px 15px;
  font-size: 12px;
  height: 35px;
  display: flex;
  align-items: center;
  border-radius: 10px;
}

.mode-info i {
  margin-right: 10px;
}

.mode-info.gold {
  color: #d1802e;
  padding: 15px;
  height: auto;
  background-color: #655950;
}

.mode-info.gold span {
  line-height: 18px;
}

.mode-info.red {
  color: #f5a2af;
  background-color: #7f3541;
}
</style>
